
 
export const FETCH_DOCUMENT_TYPES_REQUEST = 'documentTypes/FETCH_DOCUMENT_TYPES_REQUEST';
export const FETCH_DOCUMENT_TYPES_SUCCESS = 'documentTypes/FETCH_DOCUMENT_TYPES_SUCCESS';
export const FETCH_DOCUMENT_TYPES_FAILURE = 'documentTypes/FETCH_DOCUMENT_TYPES_FAILURE';

 
export const FETCH_DOCUMENT_TYPE_REQUEST = 'documentTypes/FETCH_DOCUMENT_TYPE_REQUEST';
export const FETCH_DOCUMENT_TYPE_SUCCESS = 'documentTypes/FETCH_DOCUMENT_TYPE_SUCCESS';
export const FETCH_DOCUMENT_TYPE_FAILURE = 'documentTypes/FETCH_DOCUMENT_TYPE_FAILURE';

 
export const DELETE_DOCUMENT_TYPE_REQUEST = 'documentTypes/DELETE_DOCUMENT_TYPE_REQUEST';
export const DELETE_DOCUMENT_TYPE_SUCCESS = 'documentTypes/DELETE_DOCUMENT_TYPE_SUCCESS';
export const DELETE_DOCUMENT_TYPE_FAILURE = 'documentTypes/DELETE_DOCUMENT_TYPE_FAILURE';

 
export const CREATE_DOCUMENT_TYPE_REQUEST = 'documentTypes/CREATE_DOCUMENT_TYPE_REQUEST';
export const CREATE_DOCUMENT_TYPE_SUCCESS = 'documentTypes/CREATE_DOCUMENT_TYPE_SUCCESS';
export const CREATE_DOCUMENT_TYPE_FAILURE = 'documentTypes/CREATE_DOCUMENT_TYPE_FAILURE';

 
export const UPDATE_DOCUMENT_TYPE_REQUEST = 'documentTypes/UPDATE_DOCUMENT_TYPE_REQUEST';
export const UPDATE_DOCUMENT_TYPE_SUCCESS = 'documentTypes/UPDATE_DOCUMENT_TYPE_SUCCESS';
export const UPDATE_DOCUMENT_TYPE_FAILURE = 'documentTypes/UPDATE_DOCUMENT_TYPE_FAILURE';


export const UPDATE_FIELD = 'documentTypes/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'documentTypes/SET_DEFAULT_DATA';
